(function(angular, module) {var Column, capitalizeColumnName, capitalizeFirstLetter, dataTableDirective,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

dataTableDirective = function($parse, $state) {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'util/widgets/dataTable',
    scope: true,
    link: function(scope, element, attrs) {
      var i, index, len, name, ref, results;
      scope.table = {};
      scope.table.columns = [];
      scope.$watch(attrs.tableData, function(data) {
        return scope.table.data = data;
      });
      if (attrs.totalData) {
        scope.table.hasTotal = true;
        scope.$watch(attrs.totalData, function(totals) {
          return scope.table.totals = totals;
        });
      }
      scope.columnLink = function(column, item) {
        var stateName, stateParams;
        stateName = attrs[column.normalized + 'Link'];
        stateParams = $parse(attrs[column.normalized + 'LinkParams'])(scope, {
          item: item
        });
        return $state.go(stateName, stateParams);
      };
      ref = attrs.columnNames.split(',');
      results = [];
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        name = ref[index];
        results.push(scope.table.columns.push(new Column($parse, name, scope, attrs)));
      }
      return results;
    }
  };
};

Column = (function() {
  function Column(parse, name1, scope1, attrs1) {
    this.parse = parse;
    this.name = name1;
    this.scope = scope1;
    this.attrs = attrs1;
    this.propertyMeta = {};
    this.normalized = this.attrs.$normalize(this.name.replace('_', '-'));
    this.initializeProperty('Label', capitalizeColumnName);
    this.initializeProperty('Weight', function() {
      return 1;
    });
    this.hasLink = this.attrs[this.normalized + 'Link'];
    this.dataExpression = this.attrs[this.normalized] ? this.parse(this.attrs[this.normalized]) : (function(_this) {
      return function(scope, extra) {
        return extra.item[_this.name];
      };
    })(this);
    this.totalExpresion = this.attrs[this.normalized + 'Total'] ? this.parse(this.attrs[this.normalized + 'Total']) : this.dataExpression;
  }

  Object.defineProperties(Column.prototype, {
    label: {
      get: function() {
        return this.getProperty('Label');
      }
    },
    weight: {
      get: function() {
        return this.getProperty('Weight');
      }
    }
  });

  Column.prototype.toJSON = function() {
    return {
      name: this.name,
      normalized: this.normalized,
      label: this.label,
      weight: this.weight
    };
  };

  Column.prototype.literalAttr = function(name) {
    return this.attrs["" + this.normalized + name];
  };

  Column.prototype.expressionAttr = function(name) {
    return this.attrs["" + this.normalized + name + "Exp"];
  };

  Column.prototype.initializeProperty = function(name, makeDefault) {
    var meta;
    if (makeDefault == null) {
      makeDefault = angular.noop;
    }
    meta = {};
    if (this.expressionAttr(name)) {
      meta.type = 'exp';
      meta.expression = this.parse(this.expressionAttr(name));
    } else if (this.literalAttr(name)) {
      meta.type = 'attr';
    } else {
      meta.type = 'literal';
      meta.value = makeDefault(this.name, name);
    }
    this.propertyMeta[name] = meta;
  };

  Column.prototype.getProperty = function(name, extra) {
    var meta;
    meta = this.propertyMeta[name];
    switch (meta.type) {
      case 'attr':
        return this.literalAttr(name);
      case 'exp':
        return meta.expression(this.scope, extr);
      default:
        return meta.value;
    }
  };

  Column.prototype.getData = function(item) {
    return this.dataExpression(this.scope, {
      item: item,
      value: item[this.name]
    });
  };

  Column.prototype.getTotalData = function(item) {
    return this.totalExpresion(this.scope, {
      item: item,
      value: item[this.name]
    });
  };

  return Column;

})();

capitalizeColumnName = function(name) {
  var parts, skip, word;
  skip = ['of', 'and'];
  parts = (function() {
    var i, len, ref, results;
    ref = name.split('_');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      word = ref[i];
      if (indexOf.call(skip, word) < 0) {
        results.push(capitalizeFirstLetter(word));
      }
    }
    return results;
  })();
  return parts.join(" ");
};

capitalizeFirstLetter = function(word) {
  return word[0].toUpperCase() + word.slice(1, +word.length + 1 || 9e9);
};

module.directive('dybTable', dataTableDirective);
})(angular, angular.module("dyb.util.widgets"));